import type { IQuest } from 'components/quests/loyalty-quest/types';

export const getProductRequirementCmsIds = (quest: IQuest | undefined): string[] => {
  if (!quest || !quest?.steps) {
    return [];
  }

  const allCartReqs = quest.steps.flatMap(step => step.cartRequirements ?? []);
  const allProdReqs = allCartReqs.flatMap(cartReq => cartReq ?? []);
  const ids = allProdReqs.flatMap(req => (req?.id ? [req.id] : []));

  return Array.from(new Set(ids));
};
